export default __webpack_public_path__ + "static/media/DefaultCard.8becd4a3.png";